export default {
    ADD_COMPLETE_ADDRESS_UNSET: "setAnalyzeCompleteAddressUnset",
    DELETE_COMPLETE_ADDRESS_UNSET: "setAnalyzeCompleteAddressUnsetRemove",

    //common
    SET_ANALYZE_ERROR: "setAnalyzeError",

    //continue
    SET_ANALYZE_CONTINUE_ITEMS: "setAnalyzeContinueItems",
}
